/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delete_Account_Request_FailedInputs */

const en_delete_account_request_failed = /** @type {(inputs: Delete_Account_Request_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We could not process your account deletion request. Please try again.`)
};

const es_delete_account_request_failed = /** @type {(inputs: Delete_Account_Request_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pudimos procesar tu solicitud de eliminación de cuenta. Inténtalo de nuevo.`)
};

const ar_delete_account_request_failed = /** @type {(inputs: Delete_Account_Request_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعذر معالجة طلب حذف حسابك. يرجى المحاولة مرة أخرى.`)
};

/**
* | output |
* | --- |
* | "We could not process your account deletion request. Please try again." |
*
* @param {Delete_Account_Request_FailedInputs} inputs
* @param {{ locale?: "en" | "es" | "ar" }} options
* @returns {LocalizedString}
*/
export const delete_account_request_failed = /** @type {((inputs?: Delete_Account_Request_FailedInputs, options?: { locale?: "en" | "es" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_Account_Request_FailedInputs, { locale?: "en" | "es" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delete_account_request_failed(inputs)
	if (locale === "es") return es_delete_account_request_failed(inputs)
	return ar_delete_account_request_failed(inputs)
});